import { IMPACT_CAMPAIGN_ID } from "../constants";

export const getCookie = (key) => {
    let cookieValue;
    if (document.cookie && document.cookie !== "") {
        let cookies = document.cookie.split(";");
        for (let x = 0; x < cookies.length; x++) {
            let cookie = cookies[x].trim().split("=");
            if (cookie[0] === key) {
                cookieValue = cookie[1];
                break;
            }
        }
    }

    return cookieValue;
};

export const removeCookie = (key) => {
    document.cookie = key + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}

export const getImpactCookie = () => {

    let impactCookie = getCookie("IR_" + process.env.REACT_APP_IMPACT_CAMPAIGN_ID);

    if (impactCookie) {
        impactCookie = impactCookie.split("%7C");

        return impactCookie[impactCookie.length - 2];
    } else {
        return false;
    }

};

export const getBRGPatientCookie = () => {

    let eventID = getCookie("indi-brgp-event-id");
    let emailID = getCookie("indi-brgp-id");
    let signupType = getCookie("indi-signup-type");

    if (eventID && emailID && signupType) {

        return {
            eventID,
            emailID,
            signupType
        };
    } else {
        return null;
    }
}

export const removeBRGPatientCookie = () => {
    document.cookie = `indi-brgp-id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.indimoves.com; path=/; Secure; SameSite=None`;
    document.cookie = `indi-brgp-event-id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.indimoves.com; path=/; Secure; SameSite=None`;
    document.cookie = `indi-signup-type=; expires=Thu, 01 Jan 1970 00:00:00 UTC; domain=.indimoves.com; path=/; Secure; SameSite=None`;
}